import type { TRPCClientError } from '@trpc/client'
import type { InferrableClientTypes } from '@trpc/server/unstable-core-do-not-import'
import type { ReactElement } from 'react'

import { CrashPage } from '../components/organisms/crash-page.tsx'
import { NotFound } from '../components/organisms/not-found.tsx'
import { TemporaryFailureScreen } from '../components/organisms/temporary-failure-screen.tsx'
import { Unauthorized } from '../components/organisms/unauthorized.tsx'

import { ForceUpdateDialog } from './force-update-dialog.tsx'

export function TrpcErrorHandler({ err }: { err: TRPCClientError<InferrableClientTypes> }): ReactElement | null {
  if (window.self !== window.top) {
    return <Unauthorized message="L'intégration dans une iframe n'est pas autorisée." />
  }

  switch (err.data?.code) {
    case 'CLIENT_OUTDATED':
      return <ForceUpdateDialog />
    case 'NOT_FOUND':
      return <NotFound message={err.message} />
    case 'FORBIDDEN':
    case 'UNAUTHORIZED':
      return <Unauthorized message={err.message} />
    case 'TIMEOUT':
    case 'CLIENT_CLOSED_REQUEST':
    case 'CONFLICT':
    case 'PRECONDITION_FAILED':
      return <TemporaryFailureScreen />
    default:
      return <CrashPage error={err} />
  }
}
